module.exports = __webpack_public_path__ + "agencyanalytics-wordmark-57c479967600328672c9bbedff9a5a87.webp";